import React, { useState, useEffect } from "react";
import _ from "underscore";
import { Row, Col, Card } from "react-bootstrap";
import Sidebar from "../components/SidebarRegistration";
import ErrorMdl from "../components/errorMdl";
import { useAuth } from "./../context/auth";
import { updateTokens } from "./../context/checkTokens";
import { getQueryStringValue } from "../components/search/queryString";
const axios = require("axios");
const UpdateTokenFreeTrial = (props) => {
  const { authTokens, setAuthTokens } = useAuth();

  const [hasError, setErrors] = useState(true);
  const [errorshow, setErrorShow] = useState(false);
  const [showSuccessmessage, setSuccessmessage] = useState("");

  async function sendUpdate() {
    axios
      .get(
        !_.isUndefined(process.env.REACT_APP_API_URL)
          ? process.env.REACT_APP_API_URL + "/User/UpdateTokenFreeTrial"
          : "/User/UpdateTokenFreeTrial",
        {
          params: { key: getQueryStringValue("_t") },
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res) {
          if (!_.isUndefined(res.status) && res.status === 200) {
            if (res.data.success === true) {
              setSuccessmessage(
                "Your Pro Access is now Activated. Please login and enjoy your free trial. Happy searching!"
              );
              updateTokens(authTokens, "isPro", 1);
              setAuthTokens(updateTokens(authTokens, "pro_trial", "1"));
              window.location.href = "/Home";
            } else setSuccessmessage("Activation Link already used!");
          } else {
            //todo setError;
            setErrors(res.Error);
            setErrorShow(true);
          }
        } else {
          // const error = new Error(res.error);
          setErrors({ message: "Password mismatched!" });
          setErrorShow(true);
        }
        //callback for the response
      })
      .catch((error) => {
        setErrors(error);
        setErrorShow(true);
      });
  }
  useEffect(() => {
    sendUpdate();
  }, []);
  return (
    <main role="main" className="main mt-2 container-fluid">
      <ErrorMdl error={hasError} setErrorShow={setErrorShow} show={errorshow} />

      <Row></Row>
      <Row>
        <Col md="3">
          <Sidebar {...props} />
        </Col>
        <Col md="9">
          <Row>
            <Col>
              {showSuccessmessage && (
                <Card variant="info">
                  <Card.Body>
                    <Card.Header>
                      <h2>Free Trial</h2>
                    </Card.Header>
                    {showSuccessmessage}
                  </Card.Body>
                </Card>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </main>
  );
};

export default UpdateTokenFreeTrial;
